<template>
  <div class="floor-container">
    <div class="title">{{floorData.title}}</div>
    <div class="floor-item">
        <template v-for="(item, idx) in floorData.attributeFloorContentInfoList">
            <div v-if="!item.subTitle" :class="item.active ? 'item-box' : 'item-box normal'" :key="idx" @click="!$isIframe ? selItem(floorData, idx, item) : ''">
                <span class="main-title">{{item.mainTitle}}</span>
                <img class="label-img" v-if="item.corner" src="@/assets/img/label.png" />
                <span class="label" v-if="item.corner">{{item.corner}}</span>
            </div>
            <div v-else :class="item.active ? 'item-box2' : 'item-box2 normal'" :key="idx" @click="!$isIframe ? selItem(floorData, idx, item) : ''">
                <span class="main-title">{{item.mainTitle}}</span><br/>
                <span class="sub-title" v-if="item.subTitle">{{item.subTitle}}</span>
                <img class="label-img" v-if="item.corner" src="@/assets/img/label.png" />
                <span class="label" v-if="item.corner">{{item.corner}}</span>
            </div>
        </template>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Floor',
  data: () => {
    return {
    }
  },
  props: ['floorData'],
  created () {
  },
  methods: {
    // 修改选中属性值
    selItem (floorData, idx, item) {
        this.$emit('changeSelItem', floorData, idx, item)
    }
  }
}
</script>

<style lang="scss" scoped>
  .floor-container{
    .title{
        margin: .24rem 0 .1rem .1rem;
        text-align: left;
        height: .21rem;
        font-size: .15rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: .21rem;
    }
    .floor-item{
        overflow: hidden;
        .item-box{
            float: left;
            position: relative;
            box-sizing: border-box;
            margin-left: .1rem;
            margin-top: .09rem;
            width: .93rem;
            height: .4rem;
            line-height: .4rem;
            background: #DBECFF;
            border-radius: 8px;
            border: 1px solid #1E7DFF;
            font-size: .15rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #005FFF;
            .main-title{
            }
            .label-img{
                width: 0.3rem;
                height: 0.3rem;
                position: absolute;
                right: 0;
                top: 0;
            }
            .label{
                position: absolute;
                right: -0.15rem;
                font-size: .1rem;
                width: .5rem;
                height: .15rem;
                line-height: .15rem;
                transform: rotate(45deg) scale(0.75);
                top: .03rem;
                color: #FFF;
            }
        }
        .item-box2{
            float: left;
            position: relative;
            box-sizing: border-box;
            margin-left: .1rem;
            margin-top: .09rem;
            padding-top: .1rem;
            width: 1.06rem;
            height: .8rem;
            background: #DBECFF;
            border-radius: 8px;
            border: 1px solid #1E7DFF;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #005FFF;
            .main-title{
                height: .31rem;
                font-size: .22rem;
                font-weight: 500;
                color: #005FFF;
                line-height: .31rem;
            }
            .sub-title{
                height: .185rem;
                font-size: .13rem;
                color: #005FFF;
                line-height: .185rem;
            }
            .label-img{
                width: 0.37rem;
                height: 0.37rem;
                position: absolute;
                right: 0;
                top: 0;
            }
            .label{
                position: absolute;
                right: -0.13rem;
                font-size: .1rem;
                width: .5rem;
                height: .15rem;
                line-height: .15rem;
                transform: rotate(45deg);
                top: .05rem;
                color: #FFF;
            }
        }
        .normal{
            border: 1px solid #DEDEDE;
            background: #FFF;
            color: #333;
            .main-title{
                color: #333;
            }
            .sub-title{
                color: #333;
            }
        }
    }
  }
</style>
